import {WorkspaceReservationState} from './types';

export const initialState: WorkspaceReservationState = {
  buildingId: '',
  floorId: '',
  areaId: '',
  invitees: [],
  isSavingWorkspaceReservation: false,
  deskIds: [],
};
